import store from '@/store'
import CONST from './const';
import Utils from './utils';
import MobileDetect from 'mobile-detect';

export default class mobileDetect {
  static async isIosMobile() {
    var md = new MobileDetect(window.navigator.userAgent);
    //ws://192.168.50.85:8089/NVR/ch53
    //http://192.168.50.85:8092/ch53/index.m3u8
    return (md.is('iPhone') || md.is('iPad'))
  }

  static isMobileDevice() {
    const mobileDevice = ['android', 'webos', 'iphone', 'ipad']
    let isMobileDevice = mobileDevice.some(e => navigator.userAgent.toLocaleLowerCase().match(e))
    return isMobileDevice
  }

  static isPortraitMobileDevice() {
    
  }
}